import { FormikProps } from 'formik'
import React from 'react'

import { PricesList } from '../../../api/services/pricing/types.ts'
import Input from '../../common/forms/Input/Input.tsx'

const CodePricingItem = ({
  formik,
  fieldName,
  placeholder,
  userPrices
}: {
  formik: FormikProps<any>
  fieldName: keyof PricesList
  placeholder: string
  userPrices: PricesList | undefined
}) => {
  const inputClassName = 'py-4 px-4 flex-1 text-right font-bold'
  const disabledInputClassName = 'bg-gray-100 rounded-lg'

  // Check for errors (Formik or standalone mode)
  const hasError = formik.touched?.[fieldName] && formik.errors?.[fieldName]

  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-row 3xl:flex-col items-end gap-1 px-1">
        <div>
          <span className="block 3xl:hidden text-center mb-2">
            Domyślna cenna
          </span>
          <Input
            id="month_diet_price"
            name="month_diet_price"
            type="number"
            value={userPrices ? userPrices[fieldName as keyof PricesList] : ''}
            inputClassName={inputClassName}
            className={disabledInputClassName}
            disabled={true}
          />
        </div>
        <Input
          id={fieldName}
          name={fieldName}
          type="number"
          placeholder={placeholder}
          formik={formik}
          inputClassName={inputClassName}
          useOwnError={false}
        />
      </div>

      {hasError && (
        <span className="text-red-500 text-sm pb-4">
          {formik.errors?.[fieldName] as string}
          {/* Display error depending on mode */}
        </span>
      )}
    </div>
  )
}

export default CodePricingItem
